import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { productSlug } = useLocalSearchParams<{ productSlug: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Order Product — {productSlug}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
